module.exports = __webpack_public_path__ + "img/主营业务_系统节能改造04.02a94051.png";